/* QUIET — confort mobile (29-09)
   Typographie française dans les titres, barre d'achat collante, photo produit
   qu'on fait glisser du doigt, indice de défilement des tuiles. */
(function () {
  'use strict';
  var mobile = window.matchMedia('(max-width: 760px)');

  /* ---------- Espace insécable avant ? ! : ; (le "?" ne se retrouve plus seul) ---------- */
  function fixTypo(root) {
    (root || document).querySelectorAll('h1, h2, h3, .lp-h, .q-step__q').forEach(function (h) {
      var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var t = node.nodeValue;
        var f = t.replace(/ ([?!:;»])/g, ' $1').replace(/« /g, '« ');
        if (f !== t) node.nodeValue = f;
      }
    });
  }
  fixTypo(document);

  /* ---------- Fiche produit : barre d'achat visible tant que le bouton principal est hors écran ---------- */
  var bar = document.querySelector('[data-lp-sticky-bar]');
  var trigger = document.querySelector('[data-lp-sticky-trigger]');
  if (bar && trigger && 'IntersectionObserver' in window) {
    var triggerVisible = true;
    var sync = function () {
      var on = mobile.matches && !triggerVisible;
      bar.classList.toggle('q-show', on);
      document.body.classList.toggle('q-has-sticky', mobile.matches);
    };
    new IntersectionObserver(function (entries) {
      triggerVisible = entries[0].isIntersecting;
      sync();
    }, { threshold: 0 }).observe(trigger);
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    sync();
  }

  /* ---------- Galerie produit : glisser la grande photo + compteur "2 / 5" ---------- */
  document.querySelectorAll('[data-lp-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('.lp-gallery-main');
    var track = gallery.querySelector('[data-lp-thumbs-track]');
    if (!main || !track) return;

    function thumbs() {
      return Array.prototype.filter.call(track.querySelectorAll('[data-lp-thumb]'), function (t) {
        return t.offsetParent !== null;
      });
    }
    var counter = document.createElement('span');
    counter.className = 'q-gal-count';
    counter.setAttribute('aria-hidden', 'true');
    if (getComputedStyle(main).position === 'static') main.style.position = 'relative';
    main.appendChild(counter);

    function paint() {
      var list = thumbs();
      var i = list.findIndex(function (t) { return t.classList.contains('lp-active'); });
      counter.textContent = list.length > 1 ? (Math.max(i, 0) + 1) + ' / ' + list.length : '';
      counter.style.display = list.length > 1 && mobile.matches ? '' : 'none';
    }
    new MutationObserver(paint).observe(track, { subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    paint();

    function go(step) {
      var list = thumbs();
      if (list.length < 2) return;
      var i = list.findIndex(function (t) { return t.classList.contains('lp-active'); });
      var next = list[(Math.max(i, 0) + step + list.length) % list.length];
      next.click();
      var tr = next.getBoundingClientRect();
      var tk = track.getBoundingClientRect();
      track.scrollTo({ left: track.scrollLeft + (tr.left - tk.left) - (tk.width - tr.width) / 2, behavior: 'smooth' });
    }

    var x0 = null, y0 = null, swiped = 0;
    main.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) {
        swiped = Date.now();
        e.preventDefault();
        go(dx < 0 ? 1 : -1);
      }
    }, { passive: false });
    /* Après un glissement, on n'ouvre pas le zoom */
    main.addEventListener('click', function (e) {
      if (Date.now() - swiped < 500) { e.stopPropagation(); e.preventDefault(); }
    }, true);
  });

  /* ---------- Quiz : quand le résultat s'affiche, le bouton "Ajouter au panier" est à l'écran ---------- */
  document.querySelectorAll('[data-q-result]').forEach(function (result) {
    new MutationObserver(function () {
      if (result.hidden || !mobile.matches) return;
      setTimeout(function () {
        var add = result.querySelector('[data-r-add]');
        if (!add) return;
        var r = add.getBoundingClientRect();
        if (r.bottom > window.innerHeight - 16) {
          window.scrollBy({ top: r.bottom - window.innerHeight + 32, behavior: 'smooth' });
        }
      }, 650);
    }).observe(result, { attributes: true, attributeFilter: ['hidden'] });
  });

  /* ---------- Carrousel photo de la fiche produit (téléphone) ----------
     10-10 : une seule photo de couleur à la fois. Les photos marquées data-q-color-media
     (photo d'une variante) ne s'affichent que pour la couleur choisie, sur téléphone
     (carrousel) comme sur ordinateur (vignettes). Les photos d'ambiance restent visibles.
     Les pastilles de couleur passent juste sous la photo. */
  document.querySelectorAll('[data-q-mgal]').forEach(function (gal) {
    var track = gal.querySelector('[data-q-mgal-track]');
    var all = Array.prototype.slice.call(gal.querySelectorAll('[data-q-mgal-slide]'));
    var count = gal.querySelector('[data-q-mgal-count]');
    var dotsWrap = gal.querySelector('[data-q-mgal-dots]');
    var gallery = gal.closest('[data-lp-gallery]');
    var pdp = gal.closest('[data-lp-product-form]');
    var mainImg = gallery && gallery.querySelector('[data-lp-gallery-main]');
    if (!track || !all.length) return;
    var current = 0;
    function file(u) { return (u || '').split('?')[0].split('/').pop(); }
    var colorFiles = all.filter(function (s) { return s.hasAttribute('data-q-color-media'); })
      .map(function (s) { return file(s.getAttribute('data-full-src')); });
    function slides() { return all.filter(function (s) { return !s.hidden; }); }

    function paint(i) {
      var list = slides();
      current = Math.max(0, Math.min(i, list.length - 1));
      if (count) {
        count.textContent = (current + 1) + ' / ' + list.length;
        count.style.display = list.length > 1 ? '' : 'none';
      }
      if (dotsWrap) {
        Array.prototype.forEach.call(dotsWrap.children, function (d, j) {
          d.setAttribute('aria-current', j === current ? 'true' : 'false');
        });
      }
    }
    function buildDots() {
      if (!dotsWrap) return;
      var list = slides();
      dotsWrap.innerHTML = '';
      if (list.length < 2 || list.length > 8) { dotsWrap.hidden = true; return; }
      dotsWrap.hidden = false;
      list.forEach(function (s, j) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Photo ' + (j + 1) + ' sur ' + list.length);
        b.addEventListener('click', function () { goTo(j, true); });
        dotsWrap.appendChild(b);
      });
    }
    function indexFromScroll() {
      var list = slides();
      var step = list.length > 1 ? list[1].offsetLeft - list[0].offsetLeft : track.clientWidth;
      return Math.max(0, Math.min(list.length - 1, Math.round(track.scrollLeft / (step || 1))));
    }
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; var i = indexFromScroll(); if (i !== current) paint(i); });
    }, { passive: true });
    function goTo(i, smooth) {
      var list = slides();
      var s = list[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft - list[0].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      paint(i);
    }
    /* Toucher une photo : ouvre le zoom du thème avec cette photo */
    all.forEach(function (s) {
      s.addEventListener('click', function () {
        var trigger = gallery && gallery.querySelector('[data-lp-zoom-trigger]');
        if (!trigger) return;
        trigger.src = s.getAttribute('data-full-src');
        trigger.click();
      });
    });

    /* Choix d'une couleur : n'afficher que la photo de cette couleur */
    function showColor(f) {
      if (!f || colorFiles.indexOf(f) < 0) return false;
      all.forEach(function (s) {
        if (s.hasAttribute('data-q-color-media')) s.hidden = file(s.getAttribute('data-full-src')) !== f;
      });
      if (gallery) {
        gallery.querySelectorAll('[data-lp-thumb]').forEach(function (t) {
          var tf = file(t.getAttribute('data-full-src'));
          if (colorFiles.indexOf(tf) >= 0) t.style.display = tf === f ? '' : 'none';
        });
      }
      var sb = document.querySelector('[data-lp-sticky-bar] img');
      var cs = all.filter(function (s) { return file(s.getAttribute('data-full-src')) === f; })[0];
      if (sb && cs) sb.src = cs.getAttribute('data-full-src').replace(/width=\d+/, 'width=100');
      buildDots();
      var list = slides();
      var idx = list.findIndex(function (s) { return file(s.getAttribute('data-full-src')) === f; });
      goTo(Math.max(idx, 0), false);
      return true;
    }
    if (mainImg) {
      new MutationObserver(function () {
        showColor(file(mainImg.getAttribute('src')));
      }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });
    }
    if (!(mainImg && showColor(file(mainImg.getAttribute('src'))))) { buildDots(); paint(0); }

    /* Pastilles de couleur juste sous la photo (téléphone et ordinateur) */
    if (pdp && gallery) {
      var block = null;
      pdp.querySelectorAll('.lp-option-block').forEach(function (b) {
        if (!block && b.querySelector('.lp-swatches')) block = b;
      });
      if (block) { block.classList.add('q-opt-under-gal'); gallery.appendChild(block); }
    }
  });

  /* ---------- "Pourquoi QUIET" : petit indice qu'on peut faire glisser ---------- */
  document.querySelectorAll('.q-bento').forEach(function (b) {
    if (b.children.length < 2 || b.nextElementSibling && b.nextElementSibling.classList.contains('q-bento-hint')) return;
    var hint = document.createElement('p');
    hint.className = 'q-bento-hint';
    hint.textContent = 'Faites glisser pour voir la suite →';
    b.parentNode.insertBefore(hint, b.nextSibling);
  });
})();
